<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card class="my-5 elevation-0">
          <v-card-title>
            <v-btn text small @click="$router.back()">
              <v-icon left>mdi-arrow-left</v-icon>
              Back
            </v-btn>
            <v-spacer />
            <!-- Commented out as iframe has built-in download functionality -->
            <!-- <v-btn
              @click="downloadFile(document, `${$route.params.code}.pdf`)"
              small
              color="secondary"
            >
              <v-icon left>mdi-download</v-icon>
              Download
            </v-btn> -->
          </v-card-title>

          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <v-card-text
            v-if="document"
            class="pa-0"
            style="height: 80vh; min-height: 700px; position: relative; background: #525659"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div
                  class="mt-6 grey--text text--darken-2 headline font-weight-bold"
                >
                  Rejection Letter Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your rejection letter is ready. Since you are on a mobile
                  device, please use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Rejection Letter
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Rejection Letter Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FileMixin from "../../../mixins/FileMixin";
import PdfViewerMixin from "../../../mixins/PdfViewerMixin";

export default {
  name: "RejectionLetter",
  mixins: [FileMixin, PdfViewerMixin],
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Application/getRejectionLetter", v.$route.params.code);
    });
  },
  watch: {
    document: {
      handler(val) {
        if (val) {
          this.generatePdfUrl(val);
        }
      },
      immediate: true,
    },
  },
  computed: {
    document() {
      return this.$store.getters["Application/rejectionLetter"];
    },
  },
};
</script>

<style scoped>
iframe {
  border: none;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
